/**
 * What "motion" means to a player who has asked for less of it.
 *
 * Two things move the picture without the player moving anything: the eye rides the stride, and the
 * camera is knocked by a shot. Each is a decision somebody made about how the game feels, and each
 * is somebody else unable to play.
 *
 * A closed union rather than a registry, because these are named by the modules that draw them and
 * an id nothing draws is a switch with nothing behind it. A third entry is a name here, a knob
 * file, and a read at the one place that already owns the effect: no shared file grows a branch,
 * because nothing here switches on the id.
 */

/** Every motion a player can be given back their own say over. */
export type MotionEffectId = 'headBob' | 'cameraShake';

/** Walked wherever every effect is visited, so the master switch cannot miss one. */
export const MOTION_EFFECT_ORDER: readonly MotionEffectId[] = ['headBob', 'cameraShake'];
